import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { TIPS_IFRAME_URL } from '../../constants';
import Iframe from 'components/Iframe/Iframe';
import Media from 'react-media';
import styles from 'theme';

@observer
export default class Tips extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <Media query={{ maxWidth: styles.mq.large }}>
        {matches => (
          <Iframe
            src={TIPS_IFRAME_URL}
            height={matches ? 'calc(100vh - 145px)' : '100%'}
          />
        )}
      </Media>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/tips/Tips.js